module.exports = __webpack_public_path__ + "img/newyear2024-nav@2x.24b7d711.png";